import { AsmTableType } from '../models/asm-table-type';
import { SolType, SolViewId, TypeService, ViewService } from '@sol/components';
import { AsmTableColumnWidths } from '@asm/components-core/models/asm-setting';
import { AsmTableColumnWidthsTools } from '../tools/asm-table-column-widths.tools';

export function provideAsmTableViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmTableType.tableColumnWidths);
  viewService.deriveView(SolType.string, 'edit', AsmTableType.tableColumnWidths, SolViewId.textArea, {
    isDefault: true,
    sourceViewId: SolViewId.textArea,
    mapValue: (value: AsmTableColumnWidths | string) => AsmTableColumnWidthsTools.toText(value) ?? '',
    mapValueOut: (text: string) => AsmTableColumnWidthsTools.fromText(text) ?? '',
  });
  viewService.deriveView(SolType.string.array, 'read', AsmTableType.tableColumnWidths, SolViewId.textField, {
    isDefault: true,
    mapValue: (value: AsmTableColumnWidths | string) => AsmTableColumnWidthsTools.toLines(value),
  });
}
